var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("ProgressCircular")
    : _c(
        "form",
        {
          ref: "updatePlaceForm",
          attrs: { novalidate: "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "", justify: "space-between" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "8" } },
                [
                  _c(
                    "v-card",
                    {
                      attrs: {
                        "max-width": "1200",
                        flat: "",
                        color: "transparent",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "mb-10" },
                        [
                          _c("FormHeader", {
                            attrs: {
                              loading: _vm.loading,
                              link: "page-places",
                              title: _vm.data.title
                                ? `${_vm.data.title} место`
                                : `Создать место`,
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-tabs",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        _vm._l(_vm.$options.tabs, function (tab) {
                          return _c("v-tab", { key: tab.value }, [
                            _vm._v(" " + _vm._s(tab.title) + " "),
                          ])
                        }),
                        1
                      ),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-container",
                                        [
                                          _c("InputTitleSlug", {
                                            attrs: {
                                              "is-loading": _vm.loading,
                                              title: _vm.fields.title,
                                              "title-error":
                                                _vm.validationErrors.title,
                                              slug: _vm.fields.slug,
                                              "slug-error":
                                                _vm.validationErrors.slug,
                                              isSlugEnabled: !_vm.isNew,
                                            },
                                            on: {
                                              "change:title": function (
                                                $event
                                              ) {
                                                _vm.fields.title = $event
                                              },
                                              "change:slug": function ($event) {
                                                _vm.fields.slug = $event
                                              },
                                              "input:slug":
                                                _vm.$v.fields.slug.$touch,
                                            },
                                          }),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v("Подзаголовок ("),
                                                      _c("TranslationIcon"),
                                                      _vm._v(")"),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      outlined: "",
                                                      disabled: _vm.loading,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.fields.subtitle,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.fields,
                                                          "subtitle",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "fields.subtitle",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Обложка",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.coverImageId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.coverImageId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Миниатюра",
                                                      multiple: false,
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.thumbnailId,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.thumbnailId =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("MediaFilePicker", {
                                                    attrs: {
                                                      label: "Изображения",
                                                      "file-type":
                                                        _vm.$options
                                                          .mediaTypesByKeys
                                                          .IMAGE,
                                                      value:
                                                        _vm.fields.imageIds,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.fields.imageIds =
                                                          $event
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("span", [
                                                    _vm._v("Место проведения*"),
                                                  ]),
                                                  _c("LocationAutocomplete", {
                                                    attrs: {
                                                      id: "address",
                                                      address:
                                                        _vm.fields.address,
                                                      "is-loading": _vm.loading,
                                                      "error-messages":
                                                        _vm.validationErrors
                                                          .address,
                                                    },
                                                    on: {
                                                      "set-location": function (
                                                        $event
                                                      ) {
                                                        _vm.fields.address =
                                                          $event
                                                      },
                                                      "update-location-part":
                                                        _vm.updateLocation,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("SeoSettings", {
                                                    attrs: {
                                                      data: _vm.data,
                                                      loading: _vm.loading,
                                                    },
                                                    on: {
                                                      "on-input-seo": function (
                                                        $event
                                                      ) {
                                                        _vm.fields =
                                                          Object.assign(
                                                            {},
                                                            _vm.fields,
                                                            $event
                                                          )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "PageContent",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c("DynamicListWrapper", {
                                        attrs: {
                                          list: _vm.fields.widgets,
                                          "error-messages":
                                            _vm.mixValidationErrors,
                                          "available-items":
                                            _vm.$options.availableWidgets,
                                          "copy-clipboard":
                                            _vm.mixCopyListItemClipboard,
                                          options: _vm.$options.options,
                                        },
                                        on: {
                                          "list-sort": _vm.mixListItemsReassort,
                                          add: _vm.mixCreateListItemHandler,
                                          option: _vm.mixListItemOptionHandler,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "item",
                                            fn: function ({ data }) {
                                              return [
                                                _c(data.item.type, {
                                                  tag: "component",
                                                  attrs: {
                                                    "list-item": data.item,
                                                    "error-messages":
                                                      _vm
                                                        .mixDynamicListValidationErrors[
                                                        data.itemIndex
                                                      ],
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.mixListItemChangeHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "change-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemChangeItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                    "remove-item": function (
                                                      $event
                                                    ) {
                                                      return _vm.mixListItemRemoveItemHandler(
                                                        $event,
                                                        data.itemIndex
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ]),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "4" } },
                [
                  _c("ManageSidePanel", {
                    ref: "manageSidePanel",
                    attrs: {
                      isShowSortOrder: "",
                      "is-new": !_vm.data.id,
                      "created-at": _vm.data.createdAt,
                      "updated-at": _vm.data.updatedAt,
                      "published-at": _vm.data.publishedAt,
                      author: _vm.data.author,
                      "is-loading": _vm.loading,
                      language: _vm.language,
                      translations: _vm.fields.translations,
                      "entity-id": _vm.data.id,
                      "entity-type": "place",
                      sortOrder: _vm.fields.sortOrder,
                    },
                    on: {
                      delete: function ($event) {
                        return _vm.$emit("delete-place")
                      },
                      cancel: function ($event) {
                        return _vm.$router.push({ name: "page-places" })
                      },
                      submit: _vm.submit,
                      "update-translations": function ($event) {
                        return Object.assign(_vm.fields.translations, $event)
                      },
                      "language-update": function ($event) {
                        return _vm.$emit("language-update", $event)
                      },
                      "update-sort-order": function ($event) {
                        _vm.fields.sortOrder = Number($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "info-append",
                        fn: function () {
                          return [
                            _c("StatusPicker", {
                              attrs: {
                                align: "center",
                                cols: "12",
                                title: "Статус:",
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                status: _vm.fields.status,
                              },
                              on: {
                                "status:change": function ($event) {
                                  _vm.fields.status = $event
                                },
                              },
                            }),
                            !_vm.isNew
                              ? _c(
                                  "v-row",
                                  { attrs: { align: "center" } },
                                  [
                                    _c("v-col", { attrs: { cols: "6" } }, [
                                      _c("span", [
                                        _vm._v("Посмотреть на сайте"),
                                      ]),
                                    ]),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              link: "",
                                              color: "primary",
                                              target: "_blank",
                                              href: _vm.redirerectToWebPortal,
                                              loading: _vm.loading,
                                            },
                                          },
                                          [_c("v-icon", [_vm._v("mdi-web")])],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "body",
                        fn: function () {
                          return [
                            _c(
                              "v-card",
                              { attrs: { flat: "" } },
                              [
                                _c(
                                  "v-card-subtitle",
                                  { staticClass: "grey--text" },
                                  [_vm._v(" Связи ")]
                                ),
                                _c(
                                  "v-card-text",
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        !!_vm.cities
                                          ? _c(
                                              "v-col",
                                              { attrs: { cols: "12" } },
                                              [
                                                _c("span", [_vm._v("Города")]),
                                                _c("v-select", {
                                                  attrs: {
                                                    outlined: "",
                                                    value: "4",
                                                    "item-value": "id",
                                                    "item-text": "title",
                                                    clearable: "",
                                                    items: _vm.cities,
                                                    disabled: _vm.loading,
                                                    loading: _vm.loading,
                                                  },
                                                  model: {
                                                    value: _vm.fields.cityId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.fields,
                                                        "cityId",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "fields.cityId",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "v-col",
                                          [
                                            _c("span", [
                                              _vm._v("Исторические личности"),
                                            ]),
                                            _c("v-select", {
                                              attrs: {
                                                outlined: "",
                                                "no-data-text": "Список пуст",
                                                "item-value": "id",
                                                "item-text": "name",
                                                clearable: "",
                                                multiple: "",
                                                value:
                                                  _vm.fields.historicalFigures,
                                                items: _vm.historicalFigures,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.fields.historicalFigures =
                                                    $event
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    !!_vm.placeCategories
                                      ? _c(
                                          "v-row",
                                          { attrs: { "no-gutters": "" } },
                                          [
                                            _c(
                                              "v-col",
                                              [
                                                _c("span", [
                                                  _vm._v("Категории мест *"),
                                                ]),
                                                _c("v-select", {
                                                  attrs: {
                                                    outlined: "",
                                                    id: "categoryIds",
                                                    "no-data-text":
                                                      "Список пуст",
                                                    "item-value": "id",
                                                    "item-text": "title",
                                                    multiple: "",
                                                    "error-messages":
                                                      _vm.validationErrors
                                                        .categoryIds,
                                                    value:
                                                      _vm.fields.categoryIds,
                                                    items: _vm.placeCategories,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      _vm.fields.categoryIds =
                                                        $event
                                                    },
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.fields.placeCategories
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }